import React from 'react';
import { ButtonPrimary } from './form-input';
import {logUiError} from  '../utils/LogErrorsUtil';
import BaseComponent from './BaseComponent';

const ErrorBoundaryModal = ({ error, resetErrorBoundary }) => {

  if (error) {
    logUiError(error);
  }

  return (
    <BaseComponent name={'ErrorBoundaryModal'}>
      <div role="alert" className="errors-container d-flex flex-justify-center">
        <div className="text-center py-6">
          <h2>Oops! Something went wrong!</h2>
          <div className="error-color">
            We encountered an error while attempting to log you in. Please click the 'Try
            Again' button below.
          </div>
          <div className="error-color">
            If the issue persists, please contact us at <a href="mailto:support@careticker.com">support</a>
            .
          </div>
          <div className="mt-2">Error: {error.message}</div>
          <ButtonPrimary
            cssClass="btn-secondary py-2 px-6 mt-4"
            onClick={resetErrorBoundary}
            label="Try again"
            buttonAction={'Reset error button clicked'}
            id={'btn-try-again'}
            name={'Try again'}
          />
        </div>
      </div>
    </BaseComponent>
  );
};
export default ErrorBoundaryModal;
